import { useState } from "react";
import { useMaintenanceFindOneQuery } from "gql/generated.ts";
import { CLOSE_MAINTENANCE_BANNER_KEY } from "shared/components";
import _ from "lodash";
import { createMultilingual } from "shared/utils";

export const useMaintenance = () => {
  const [isMaintenanceBannerOpen, setIsMaintenanceBannerOpen] = useState(false);

  const {
    data: maintenanceData,
    loading: maintenanceLoading,
    error: maintenanceError,
  } = useMaintenanceFindOneQuery({
    onCompleted: (data) => {
      if (data.maintenanceFindOne?.banner.isLive) {
        setIsMaintenanceBannerOpen(true);
      }
    },
  });

  const getHashMessage = () => {
    const message =
      maintenanceData?.maintenanceFindOne?.banner.message ??
      createMultilingual("");
    const flatMessage = _(message)
      .omit("__typename")
      .values()
      .join("")
      .valueOf();
    return Array.from(flatMessage)
      .map((char) => char.charCodeAt(0))
      .join("");
  };

  const closeMaintenanceBannerValue = localStorage.getItem(
    CLOSE_MAINTENANCE_BANNER_KEY,
  );

  // Pull the local storage data & check if the start & end date of the closed
  // banner is the same as the current maintenance notice dates
  const isCurrentMaintenanceBannerClosed = !!(
    closeMaintenanceBannerValue &&
    closeMaintenanceBannerValue === getHashMessage()
  );

  const showMaintenanceBanner =
    isMaintenanceBannerOpen && !isCurrentMaintenanceBannerClosed;

  return {
    maintenanceData,
    maintenanceLoading,
    maintenanceError,
    showMaintenanceBanner,
    showMaintenanceDoorstop:
      maintenanceData?.maintenanceFindOne?.doorstop.isLive,
    handleClose: () => setIsMaintenanceBannerOpen(false),
    getHashMessage,
  };
};
